import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import InputAdornment from '@mui/material/InputAdornment';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import useDebounceFunction from '../Hooks/useDebouncedFunction';

export type LazyTextFieldProps = {
  loading?: boolean;
  disableOnLoading?: boolean;
  onChangeWithDebounce?: (value: string) => void;
  testId?: string;
} & Omit<MuiTextFieldProps, 'onChange'>;

const LazyTextField = ({
  loading,
  disabled,
  onChangeWithDebounce,
  InputProps,
  disableOnLoading = true,
  ...props
}: LazyTextFieldProps) => {
  const { handleDebounceFunction } = useDebounceFunction({ debounceTime: 1000 });

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (onChangeWithDebounce) {
      handleDebounceFunction(() => onChangeWithDebounce(event.target.value));
    }
  };

  return (
    <MuiTextField
      variant="standard"
      disabled={(loading && disableOnLoading) || disabled}
      {...props}
      onChange={handleChange}
      slotProps={{
        input: {
          ...InputProps,
          endAdornment: loading ? (
            <InputAdornment position="end">
              <Fade in={loading}>
                <CircularProgress size={16} />
              </Fade>
            </InputAdornment>
          ) : (
            InputProps?.endAdornment
          ),
        },
        htmlInput: {
          ...InputProps?.inputProps,
          'test-id': props.testId,
        },
      }}
    />
  );
};

export default LazyTextField;
